import React from "react";

const ListItem = ({ item, className }) => {

  return (
    <div className={className}>
      <div className="list-item-title">{item.title}</div>
      <div className="list-item-value">{item.value}</div>
    </div>
  );
};

ListItem.defaultProps = {
  item: {},
  className: ""
};

export default ListItem;
